import { render, staticRenderFns } from "./templateSingleOption.vue?vue&type=template&id=14af15b0&scoped=true"
import script from "./templateSingleOption.vue?vue&type=script&lang=js"
export * from "./templateSingleOption.vue?vue&type=script&lang=js"
import style0 from "./templateSingleOption.vue?vue&type=style&index=0&id=14af15b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14af15b0",
  null
  
)

export default component.exports